import { IconProps } from './icon';

export const PinOutlineIcon = (props: IconProps): JSX.Element => {
	const { size = 24, ...extraProps } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			{...extraProps}
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4" />
			<path d="M9 15l-4.5 4.5" />
			<path d="M14.5 4l5.5 5.5" />
		</svg>
	);
};
